export const defaultTextConfig = {
    fileFormatErrorText: 'Failed, file format error',
    fileSizeErrorText: 'Error, file size exceeded. (Max. 10MB)',
    uploadingText: 'Uploading...',
    dragandDropText: 'Drop files here.',
    tableFileText: 'File Name',
    tableStatusText: 'Status',
    tableActionText: 'Action',
    uploadingActionText: 'Cancel',
    uploadInProgressText: 'upload is in progress',
    uploadSuccessText: 'uploaded successfully',
    replaceSuccessText: 'replaced successfully'
};
